import type { FormEvent } from 'react';

// Grow a textarea to fit its content so it never needs a scrollbar. Reset to
// 'auto' first so it can also shrink back when text is deleted. Paired with a
// character cap (maxLength) the height stays naturally bounded.
export function autoGrowTextarea(e: FormEvent<HTMLTextAreaElement>) {
  const el = e.currentTarget;
  el.style.height = 'auto';
  el.style.height = `${el.scrollHeight}px`;
}
